export const dialogStyles = {
  paragraphStyle: { marginTop: '1em' }
}

